import { apiSlice } from "../../../app/api/apiSlice";

export const importTpoStatusApiSlice = apiSlice.injectEndpoints({
	endpoints: (builder) => ({
		importTpoStatus: builder.mutation({
			query: () => ({
				url: `/api/v1/org_tpo/get_latest_status/`,
				method: "GET",
			}),
		}),
	}),
});

export const { useImportTpoStatusMutation } = importTpoStatusApiSlice;
